
export const REGISTER = "REGISTER"
export const VERIFYOTP = "VERIFYOTP"
export const LOGIN = "LOGIN"
export const FORGETPASSWORD = "FORGETPASSWORD"
export const RESETPASSWORD = "RESETPASSWORD"
export const RESENDOTP = "RESENDOTP"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"